import React,{ useState, useEffect} from 'react'
import {SubmitButton, InputBox, AuthBox, Form, QRContainer, LoginBackground, Alert,HelpText} from '../styles/LoginStyle.js'
import {Header,Text,ContainerVertical,AlertText} from '../styles/style.js';
import {Auth} from 'aws-amplify';
import QRHelp from './LoginComponents/QRHelp.jsx'
import QRCode from "react-qr-code";
import NewPassword from './LoginComponents/NewPassword.jsx';

export default function Login(props){
	const [email,setEmail] = useState('');
	const [password,setPassword] = useState('');
	const [showQRCode,setShowQRCode] = useState(false);
	const [QRCodeValue,setQRCodeValue] = useState('');
	const [showQRHelp,setShowQRHelp] = useState(false);
	const [setupCode,setSetupCode] = useState('');
	const [setupText,setSetupText] = useState('Copy Setup');
	const [userCodeValue,setUserCodeValue] = useState('');
	const [showNewPass,setShowNewPass] = useState(false);
	const [alert,setAlert] = useState(false);
	const [alertMessage,setAlertMessage] = useState('');
	const [showCode,setShowCode] = useState(false);
	const [codeSuccess,setCodeSuccess] = useState(false);
	const [loginText,setLoginText] = useState('Verify');
	const [showLogin,setShowLogin] = useState(true)
	const [user,setUser] = useState();

	useEffect(()=>{
		
	},[])

	const handleCodeSetup = event =>{
		event.preventDefault();
		verifyToken();
	}

	function resetAlert(){
		setAlert(false)
		setAlertMessage('')
	}

	async function handleCodeSubmit(codeValue){
		setLoginText('Verifying...')
		document.getElementById('auth_button').classList.add('loading');
		try {
			await Auth.confirmSignIn(
				user,   // Return object from Auth.signIn()
				codeValue,   // Confirmation code  
				'SOFTWARE_TOKEN_MFA' // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
			).then((data) =>{
				props.successfulLogin()
			})
		}catch (err){
			document.getElementById('auth_button').classList.remove('loading');
			setLoginText('Verify')
			setAlert(true)
			if(err.message === 'Your software token has already been used once.'){
				setAlertMessage('This code was used for authenticator setup, ' +
				'please wait for a new code')
			}else{
				setAlertMessage(err.message)
			}
		}
	}

	async function signIn() { 
		if(email === ''){
			setAlert(true)
			setAlertMessage('Please enter in your email')
		}else if(password === ''){
			setAlert(true)
			setAlertMessage('Please enter in your password')
		}else{
			try {
				var user = await Auth.signIn(email, password)
				setUser(user)
				if (user.challengeName === 'SMS_MFA' || 
					user.challengeName === 'SOFTWARE_TOKEN_MFA') {
					setShowCode(true)
					setShowLogin(false)
					resetAlert();
				}else if (user.challengeName === 'NEW_PASSWORD_REQUIRED'){
					setShowNewPass(true)
					setShowLogin(false)
					resetAlert();
				}else{
					await Auth.setupTOTP(user).then((code) =>{
						setQRCodeValue("otpauth://totp/" + email + "?secret=" + code + "&issuer=Seidr Client Portal")
						setShowQRCode(true)
						setSetupCode(code)
						setShowLogin(false)
						resetAlert();
					});
				}

			} catch (err) {
				setAlert(true)
				if(err.message === 'User is not confirmed.') {
					setAlertMessage('Email is not verified.')
				}else{
					setAlertMessage(err.message)
				}
			}
		}
	}

	async function verifyToken(){
		try{
			await Auth.verifyTotpToken(user, userCodeValue).then(async () => {
				await Auth.setPreferredMFA(user, 'TOTP').then(data =>{
					
					setShowQRCode(false)
					setCodeSuccess(true);
					setTimeout(() => {
						setCodeSuccess(false);
						signIn()
					}, 3000)
					
					resetAlert();
				});
			});
		}catch(err){
			setAlert(true)
			setAlertMessage('Invalid code received for user')
		}
	}

	const copyCode = e =>{
		e.preventDefault();
		setSetupText('Copied')
		setTimeout(() =>{
			setSetupText('Copy Setup')
		},3000)
		navigator.clipboard.writeText(setupCode);
	}

	const passwordChanged = newPassword =>{
        showNewPass(false)
        setShowLogin(true)
        setPassword(newPassword)
    }

	const handleSignIn = e =>{
		e.preventDefault();
		signIn()
	}

	
	return(
		<LoginBackground>
			<Header></Header>
			{showLogin &&
				<Form>
					{alert && 
						<AlertText>{alertMessage}</AlertText>
					}
					<InputBox 
						placeholder="Email" 
						type='email' name='email' 
						value={email} 
						onChange={e =>{setEmail(e.target.value.toLowerCase())}} 
						maxLength='50'>
					</InputBox>
					<InputBox 
						placeholder="Password" 
						type='password' 
						name='password' 
						value={password} 
						onChange={e => setPassword(e.target.value)}>
					</InputBox>
		
					<ContainerVertical>
						<SubmitButton onClick={handleSignIn}>Login</SubmitButton>
					</ContainerVertical>
				</Form>
			}

			{showQRHelp && 
				<QRHelp helpDone={()=>{setShowQRHelp(false)}}></QRHelp>
			}

			{(showQRCode && !showQRHelp) &&
				<Form>
					<Text>
						Scan QR code or copy setup code into your authenticator app. 
						&nbsp;<HelpText onClick={()=>{setShowQRHelp(true)}}>Help</HelpText>
					</Text>
					<QRContainer>
						<QRCode value={QRCodeValue} size={190}/>
					</QRContainer>
					<SubmitButton onClick={copyCode}>
						{setupText}
					</SubmitButton>
					{alert && 
						<AlertText>{alertMessage}</AlertText>
					}
					<AuthBox 
						placeholder="Authenticator Code" 
						type='text' 
						name='userCodeValue' 
						value={userCodeValue} 
						id='userCodeValue' 
						onChange={e => setUserCodeValue(e.target.value)} 
						maxLength='6'>
					</AuthBox>
					<SubmitButton onClick={handleCodeSetup}>
						Submit
					</SubmitButton>
				</Form>
			}
	
			{showCode &&
				<Form onSubmit={(e) =>{e.preventDefault()}}>
					<Text>Enter Authenticator Code</Text>
					{alert && 
						<AlertText>{alertMessage}</AlertText>
					}
					<AuthBox 
						placeholder="Authenticator Code" 
						type='text' 
						name='codeValue' 
						defaultValue='' 
						id ='codeValue' 
						maxLength='6' 
						onChange={(e) =>{
							if(e.target.value.length === 6){
								handleCodeSubmit(e.target.value)
							}
						}}>
					</AuthBox>
					<SubmitButton id='auth_button'>{loginText}</SubmitButton>
				</Form>
			}

			{codeSuccess && 
				<Alert>
					<Text>QRCode setup was successful!</Text>
				</Alert>
			}

			{showNewPass &&
				<NewPassword user={user} passwordChanged={passwordChanged}></NewPassword>
			}
		</LoginBackground>
	)
}